import Auth from '@js/plugins/auth';

export default {
    computed: {
        canManagePricebooks() {
            return Auth.hasPermissionTo('franchise_manage_pricebooks');
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/pricebook/pricebook-permission.js